<template lang="pug">
v-list-item.Comment
  v-list-item-content.content(@click="$emit('click')")
    v-list-item-title.h3(v-show="!tag.isRead") {{ comment.commentText }}
    v-list-item-title(v-show="tag.isRead") {{ comment.commentText }}
    v-card-title.py-0
      span.body-1.blue-grey--text {{ this.dateWithFormat + ' | ' + comment.user.name + ' ' + comment.user.lastName }}
  v-list-item-action
   v-icon(@click="$emit('hide'); tag.isRead = false") mdi-eye-off
</template>

<script>
export default {
  name: 'Comment',
  props: {
    comment: {
      type: Object,
      default: () => ({}),
    },
    tag: {
      type: Object,
      default: () => ({}),
    },
  },
  computed:
  {
    userTz(){
      let storeTZ = _.get(this.$store.state.user, 'user.ianaTimeZone');
      return _.isEmpty(storeTZ) ? 'Etc/GMT' : storeTZ;
    },
    dateWithFormat()
    {
      let convertedDate =  this.$dateTimezoneConvert(comment.createdAt, 'Etc/GMT', this.userTz);
      return this.$dateFormatted(convertedDate);
    }
  },
  data: () => ({})
}
</script>

<style lang="stylus" scoped>
.Comment
  .content
    cursor: pointer;
  .v-card__text
    height: 200px;
    overflow: hidden
    text-overflow: ellipsis;
  &:hover
    background-color: lighten(grey, 40)
</style>

